module.exports = __webpack_public_path__ + "img/WTM-women.4102394e.svg";